import React from 'react';

/**
 * Toast Notification Component
 * Shows error or success messages as floating notifications
 */
const ToastNotification = ({ type = 'error', message, onClose }) => {
  if (!message) return null;
  
  const bgColor = type === 'error' ? 'bg-red-600' : 'bg-green-600';
  const hoverColor = type === 'error' ? 'hover:text-red-200' : 'hover:text-green-200';
  const title = type === 'error' ? 'Error:' : 'Success:';
  
  return (
    <div className={`fixed top-4 right-4 ${bgColor} text-white p-4 rounded-lg shadow-lg z-50 max-w-md`}>
      <div className="flex justify-between items-start">
        <div>
          <strong>{title}</strong>
          <p className="mt-1">{message}</p>
        </div>
        <button 
          onClick={onClose}
          className={`text-white ${hoverColor} text-xl leading-none ml-4`}
        >
          ×
        </button>
      </div>
    </div>
  );
};

/**
 * Error Toast - convenience wrapper
 */
export const ErrorToast = ({ message, onClose }) => (
  <ToastNotification type="error" message={message} onClose={onClose} />
);

/**
 * Success Toast - convenience wrapper
 */
export const SuccessToast = ({ message, onClose }) => (
  <ToastNotification type="success" message={message} onClose={onClose} />
);

export default ToastNotification;
